<template>
  <div class="flex justify-center mt-8 mb-6">
    <button 
      @click="changePage(currentPage - 1)" 
      :disabled="currentPage === 1"
      class="pagination-btn hover:text-primary-500 hover:border-primary-300"
      :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
    >
      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
      </svg>
    </button>
    
    <button 
      v-for="page in totalPages" 
      :key="page" 
      @click="changePage(page)"
      class="pagination-btn hover:bg-primary-50 hover:border-primary-300"
      :class="currentPage === page ? 'pagination-btn-active' : ''"
    >
      {{ page }}
    </button>
    
    <button 
      @click="changePage(currentPage + 1)" 
      :disabled="currentPage === totalPages"
      class="pagination-btn hover:text-primary-500 hover:border-primary-300"
      :class="{ 'opacity-50 cursor-not-allowed': currentPage === totalPages }"
    >
      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuestionPagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.$emit('page-changed', page);
    }
  }
}
</script>

<style scoped>
/* 样式已经在App.vue全局样式中定义 */
</style> 